import { render, staticRenderFns } from "./tradeFixPrice.vue?vue&type=template&id=019e05ac&scoped=true&"
import script from "./tradeFixPrice.vue?vue&type=script&lang=js&"
export * from "./tradeFixPrice.vue?vue&type=script&lang=js&"
import style0 from "./tradeFixPrice.vue?vue&type=style&index=0&id=019e05ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019e05ac",
  null
  
)

export default component.exports